import * as React from 'react';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';

export function useHeaderConfig() {
  const { telemetryClient: telemetryHook } = React.useContext(Context as React.Context<IEmployeeExperienceContext>);

  return {
    headerLabel: __APP_NAME__,
    appNameSettings: {
      label: __APP_NAME__,
    },
    telemetryHook,
  };
}
